import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MAIN_SITE_URL } from '@/data/site';
import { isSupportedLanguage } from '@/data/languages';

export default function NotFound() {
  const location = useLocation();
  const { t } = useTranslation();

  const firstSegment = location.pathname.split('/').filter(Boolean)[0];
  const lang = isSupportedLanguage(firstSegment) ? firstSegment : 'en';

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 py-20 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-primary-100">
        <i className="ri-compass-3-line text-3xl leading-none text-primary-700"></i>
      </span>

      <h1 className="mt-8 font-heading text-6xl font-semibold text-foreground-950 md:text-7xl">404</h1>

      <p className="mt-4 font-heading text-xl font-semibold text-foreground-950 md:text-2xl">
        {t('notFound.title')}
      </p>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-600 md:text-base">
        {t('notFound.desc')}
      </p>

      <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
        <Link
          to={`/${lang}`}
          className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
        >
          {t('notFound.backHome')}
        </Link>
        <a
          href={MAIN_SITE_URL}
          target="_blank"
          rel="noopener nofollow"
          className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-background-100"
        >
          {t('buttons.visitMainSite')}
        </a>
      </div>
    </div>
  );
}